export default __webpack_public_path__ + "static/media/why-choose-us.5ec7e3b2.png";